export const openInNewTab = (href: string) => {
  window.open(href, '_blank', 'noopener,noreferrer');
};
